import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { resumeItems, resumeCategories } from '../data/personalData';

const typeIcon: Record<string, string> = {
  experience: '>',
  education: '#',
  certification: '+',
  leadership: '~',
};

export const EducationExperience: React.FC = () => {
  const [filter, setFilter] = useState('all');
  const items = filter === 'all' ? resumeItems : resumeItems.filter((r) => r.type === filter);

  return (
    <section id="experience" className="py-24 px-6 bg-surface/30">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <p className="font-mono text-sm text-accent mb-2">$ cat career.log</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-text">experience &amp; education</h2>
        </motion.div>

        <div className="flex flex-wrap gap-2 mb-8 font-mono text-xs">
          {resumeCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setFilter(cat.id)}
              className={`px-3 py-1.5 rounded border transition-colors ${
                filter === cat.id
                  ? 'border-accent text-accent bg-accent/10'
                  : 'border-border text-muted hover:text-text'
              }`}
            >
              {cat.icon} {cat.label}
            </button>
          ))}
        </div>

        <div className="space-y-4">
          {items.map((item, i) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="rounded-lg border border-border bg-surface p-5 hover:border-accent/40 transition-colors"
            >
              <div className="flex flex-wrap items-start justify-between gap-2 mb-2">
                <div className="flex items-center gap-2">
                  <span className="font-mono text-accent">{typeIcon[item.type]}</span>
                  <h3 className="font-semibold text-text">{item.title}</h3>
                </div>
                {item.period && (
                  <span className="font-mono text-xs text-muted shrink-0">{item.period}</span>
                )}
              </div>
              <p className="text-sm text-accent2 font-mono mb-2">{item.organization}</p>
              {item.description && (
                <p className="text-sm text-muted leading-relaxed mb-3">{item.description}</p>
              )}
              {item.achievements && item.achievements.length > 0 && (
                <ul className="space-y-1.5 mb-3">
                  {item.achievements.map((a, idx) => (
                    <li key={idx} className="text-sm text-muted flex gap-2">
                      <span className="text-accent mt-0.5 shrink-0">▸</span>
                      <span>{a}</span>
                    </li>
                  ))}
                </ul>
              )}
              {item.skills.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                  {item.skills.map((s) => (
                    <span
                      key={s}
                      className="px-2 py-0.5 text-[11px] font-mono rounded border border-border text-muted"
                    >
                      {s}
                    </span>
                  ))}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
